module.exports = __webpack_public_path__ + "fonts/fa-light-300.c6577d3.ttf";